import { TranscriptSchema } from "../../schemas/transcript";
/**
 * Parse transcript from Markdown format.
 * Lines beginning with **Clinician:** or **Patient:** set speaker.
 */
export function parseMarkdownTranscript(content) {
    const entries = content
        .split("\n")
        .map(line => line.trim())
        .filter(Boolean)
        .map(line => {
        if (line.startsWith("**Clinician:**")) {
            return {
                speaker: "clinician",
                text: line.replace("**Clinician:**", "").trim(),
            };
        }
        if (line.startsWith("**Patient:**")) {
            return {
                speaker: "patient",
                text: line.replace("**Patient:**", "").trim(),
            };
        }
        return { speaker: "other", text: line };
    });
    return TranscriptSchema.parse({ entries });
}
